<template>
  <page>
    <div slot="headerLeft">
      <el-select clearable v-model="params.spId" :placeholder="$t('deviceList.customer')">
        <el-option
          v-for="item in serviceList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <el-select
        clearable
        v-model="params.modelId"
        :placeholder="$t('statisticalManagement.deviceType')"
      >
        <el-option
          v-for="item in modelList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <!-- <el-select clearable v-model="params.groupId" placeholder="设备分组">
        <el-option
          v-for="item in groupList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->
      <el-button type="primary" plain @click="getData">{{ $t('query') }}</el-button>
    </div>

    <div class="common-tab">
      <span
        @click="currentType = item.type"
        :class="{ active: currentType === item.type }"
        v-for="item in spanItems"
        :key="item.type"
        class="spanItem"
        >{{ item.name }}</span
      >
    </div>

    <component
      ref="chart"
      :spId="params.spId"
      :modelId="params.modelId"
      :groupId="params.groupId"
      :currentType="currentType"
      :is="currentType"
    />
  </page>
</template>

<script>
import ByTemperature from './component/ByTemperature.vue'
import ByMemory from './component/ByMemory.vue'
import ByStorage from './component/ByStorage.vue'

export default {
  data() {
    return {
      currentType: 'ByTemperature',
      params: {
        spId: '',
        modelId: '',
        groupId: ''
      },
      spanItems: [
        {
          type: 'ByTemperature',
          name: this.$t('statisticalManagement.byCPUTemperature')
        },
        {
          type: 'ByMemory',
          name: this.$t('statisticalManagement.byMemoryPercentage')
        },
        {
          type: 'ByStorage',
          name: this.$t('statisticalManagement.byStoragePercentage')
        }
      ],
      serviceList: [],
      modelList: [],
      groupList: []
    }
  },
  created() {
    this.getSelectData()
  },
  components: {
    ByTemperature,
    ByMemory,
    ByStorage
  },
  methods: {
    async getSelectData() {
      let result = await Promise.all([
        this.$api.deviceManagement.groupList({ pageSize: -1 }),
        this.$api.deviceManagement.modelList({ pageSize: -1 }),
        this.$api.systemManagement.spList({ pageSize: -1 })
      ])

      this.groupList = result[0].result.list.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
      this.modelList = result[1].result.list.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })

      this.serviceList = result[2].result.list.map(item => {
        return {
          label: item.name,
          value: item.spId
        }
      })
    },
    async getData() {
      this.$refs.chart.getData({
        spId: this.params.spId,
        modelId: this.params.modelId,
        groupId: this.params.groupId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.timeFrame,
.picker-wrap {
  display: flex;
  align-items: center;
}
</style>
